import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createSetKanoPrioCommand } from '../../../api/commands/factory/createPrioCommands';
import { KanoPrioValue } from '../../../api/queries';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetKanoPrio extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetKanoPrio';

    public constructor(public cardId: string, public priority: KanoPrioValue) {
        super(SetKanoPrio.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetKanoPrio): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createSetKanoPrioCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetKanoPrio): void => {
    const card = state.subtasks.find((x) => x.id === action.cardId);

    card.kanoPrioValue = action.priority;
    card.lastUpdatedAt = new Date();
};

//@ts-ignore
registerMiddleware(SetKanoPrio.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetKanoPrio.ACTION_TYPE, reducer);
